import icons from '@/assets/icons'
import SJButton from '@/components/SJButton'
import SJCard from '@/components/SJCard'
import SJCell from '@/components/SJCell'
import { orderBack } from '@/services/payment'
import { BackReq } from '@/services/types/payment'
import { Picker } from 'antd-mobile'
import { useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './index.less'

const BackReasons = [
  [
    { value: '1', label: '无条件退款' },
    { value: '2', label: '无法参加评测' },
    { value: '0', label: '其他原因' },
  ],
]

type State = {
  orderCode: string
  amount: string
}

const Index = () => {
  document.title = '申请退款'
  const navigate = useNavigate()
  const { state } = useLocation() as { state: State }
  const { orderCode, amount } = state
  const [reasonIndex] = useState(0)
  const [value, setValue] = useState<(string | null)[]>(['0'])

  const reasonCode = useMemo(() => {
    return Number(BackReasons[0][reasonIndex].value)
  }, [reasonIndex])

  const [done, setDone] = useState(false)

  const handleBack = async () => {
    try {
      const params: BackReq = {
        orderCode: orderCode,
        backAmount: Number(amount),
        reasonCode: reasonCode,
      }
      await orderBack(params)
      setDone(true)
    } catch (error) {}
  }
  const goBack = () => {
    navigate(-3)
  }

  // const onReasonChange = (e) => {
  //   setReasonIndex(e.detail.value)
  // }

  return (
    <div className="page order-back">
      <div className="main">
        {!done ? (
          <>
            <SJCard className="reason">
              <Picker columns={BackReasons} value={value} onConfirm={setValue}>
                {(items, { open }) => {
                  return (
                    <SJCell
                      className="hoverClass"
                      title="退款原因"
                      indicator
                      detail={BackReasons[0][reasonIndex].label}
                      onClick={open}
                    ></SJCell>
                  )
                }}
              </Picker>
              <SJCell className="hoverClass" title="退款金额" detail={'¥' + amount}></SJCell>
            </SJCard>
            <div className="title">温馨提示：</div>
            <div className="p">1、优惠券不予返还</div>
            <div className="p">2、订单一旦取消，无法恢复</div>
            <div className="btn-fixed">
              <SJButton onClick={handleBack}>申请退款</SJButton>
            </div>
          </>
        ) : (
          <>
            <SJCard className="result">
              <img className="icon-success" src={icons.IconSuccess} alt="" />
              <div className="done">退款申请已受理</div>
              <div className="desc">系统将在1-3个工作日内退款至您的账户</div>
            </SJCard>
            <div className="btn-fixed">
              <SJButton onClick={goBack}>关闭</SJButton>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Index
